import { connect } from 'react-redux';
import get from 'lodash/get';
import { SAVE_LEVEL } from '../../../../../constants/Level';
import { getThirdpartyConfiguration, saveLocalChanges } from '../../../../../actions/thirdparty';
import { modalContentInfoActions as ModalContentInfoActions } from '../../../../modals/ModalManageContentInfo';
import { ManageDomains } from './ManageDomains';

const mapStateToProps = state => ({
    chainId: state.app.selected.chain.Id,
    cspConfiguration: state.app.selected.level === SAVE_LEVEL.CHAIN ? 'chainCspConfiguration' : 'hotelCspConfiguration',
    hotelId: state.app.selected.selectedHotel.id,
    selectedLevel: state.app.selected.level,
    thirdparty: get(state, 'app.data.thirdparty', {}),
    hasAccess: _.indexOf(state.oauth.userPermissionLevels, state.app.selected.level) !== -1,
    inContextBeta: get(state, 'app.selected.inContextBeta')
});

const mapDispatchToProps = dispatch => ({
    onPageLoad: (chainId, hotelId, selectedLevel) =>
        dispatch(getThirdpartyConfiguration(chainId, hotelId, selectedLevel)),
    saveLocalChanges: (savedData, domainListKey) => {
        dispatch(saveLocalChanges(savedData, domainListKey));
    },
    showModalInfo: contentData => dispatch(ModalContentInfoActions.show(contentData))
});

export default connect(mapStateToProps, mapDispatchToProps)(ManageDomains);



// WEBPACK FOOTER //
// ./src/components/pages/manage/domains/ManageDomains/index.js